import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
} from '@angular/core'
import {Observable, BehaviorSubject, combineLatest} from 'rxjs'
import {map} from 'rxjs/operators'
import {ContextService} from '@app/core/services/context.service'
import {getDateInTz} from './multi-tz-date.util'

@Component({
  selector: 'multi-tz-date',
  template: `
    @if (date) {
      <span
        [ngbTooltip]="dateListTemplate"
        container="body"
        [placement]="placement"
        triggers="hover focus"
        >{{ timeString$ | async }}</span
      >
      <ng-template #dateListTemplate>
        <div>
          <dl class="dl-horizontal">
            <dt>Browser</dt>
            <dd>{{ getDateInTz('Browser', date, tooltipFormat) }}</dd>
            @if (terminalTz) {
              <dt>Terminal</dt>
            }
            @if (terminalTz) {
              <dd>{{ getDateInTz('Terminal', date, tooltipFormat) }}</dd>
            }
            <dt>UTC</dt>
            <dd>{{ getDateInTz('UTC', date, tooltipFormat) }}</dd>
          </dl>
        </div>
      </ng-template>
    } @else {
      <span>Date not set</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MultiTzDateComponent implements OnInit, OnChanges {
  @Input() date
  @Input() format: string = 'DD-MM-YYYY HH:mm:ss' // Removed Z from default format
  @Input() tooltipFormat: string = 'DD-MM-YYYY HH:mm:ss Z' // Added separate tooltip format with timezone
  @Input() terminalTz: string = null
  @Input() placement: string = 'auto'
  timeString$: Observable<string>
  date$ = new BehaviorSubject(null)

  constructor(private context: ContextService) {}

  ngOnInit() {
    this.timeString$ = combineLatest(
      this.context.activeTimezone$,
      this.date$,
    ).pipe(map(([x, date]) => this.getDateInTz(x, date, this.format)))
  }

  getDateInActiveTz(date: string) {
    return this.getDateInTz(this.context.activeTimezone, date, this.format)
  }

  getDateInTz(tz: string, date: string, formatToUse: string) {
    return getDateInTz(tz, date, formatToUse, this.terminalTz)
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.date$.next(changes.date.currentValue)
  }
}
